import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo/logo-portrait.png'


const _hoisted_1 = { class: "m-auto m-1230" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "mw-480 ms-lg-auto mt-5" }
const _hoisted_5 = { class: "form-group mb-4" }
const _hoisted_6 = { class: "form-group mb-4" }

import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { LoginPayload, LoginResponseInterface } from "@/types/auth";
import { useAuthStore } from "@/stores/auth";
import { ref } from "vue";
import { toast } from "vue-sonner";
import PageLoading from "@/components/Common/PageLoading.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const isLoading = ref(false);
const authStore = useAuthStore();
const loginResponse = ref<LoginResponseInterface>();

const validationSchema = toTypedSchema(
  zod.object({
    email: zod.string().nonempty({ message: "Email is Required" }),
    password: zod.string().min(6).nonempty(),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const { value: email } = useField<string>("email");
const { value: password } = useField<string>("password");

const onSubmit = handleSubmit(async () => {
  isLoading.value = true;
  const payloadLogin: LoginPayload = {
    email: email.value,
    password: password.value,
  };

  const { success, message } = await authStore.dispatchLogin(payloadLogin);

  if (success == true) {
    loginResponse.value = await authStore.authResponse;
    setTimeout(() => {
      isLoading.value = false;
      toast.success("Login Successfully");
    }, 1000);
    setTimeout(() => {
      window.location.href = "/dashboard";
    }, 1500);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isLoading.value)
      ? (_openBlock(), _createBlock(PageLoading, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-lg-6 d-none d-lg-block" }, [
          _createElementVNode("img", {
            src: _imports_0,
            class: "rounded-3",
            alt: "login"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "fs-28 mb-2" }, "Welcome back to", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "fs-28 mb-2" }, "Ship Store Management System", -1)),
            _createElementVNode("form", {
              onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
              class: "row g-3 needs-validation form"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "label text-secondary" }, "Email Address", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
                  class: "form-control h-55",
                  placeholder: "Type email"
                }, null, 512), [
                  [_vModelText, _unref(email)]
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "label text-secondary" }, "Password", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
                  class: "form-control h-55",
                  placeholder: "Type password"
                }, null, 512), [
                  [_vModelText, _unref(password)]
                ])
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "form-group mb-4" }, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary fw-medium py-2 px-3 w-100"
                }, [
                  _createElementVNode("div", { class: "d-flex align-items-center justify-content-center py-1" }, [
                    _createElementVNode("i", { class: "material-symbols-outlined text-white fs-20 me-2" }, " login "),
                    _createElementVNode("span", null, "Login")
                  ])
                ])
              ], -1))
            ], 32)
          ])
        ])
      ])
    ])
  ], 64))
}
}

})